export default __webpack_public_path__ + "static/media/LAO.fb736fb5.svg";